import { createAction, props } from '@ngrx/store';
import { Color } from '../../../api/models/color.model';


export const loadRGBColors = createAction(
    '[RGB Colors] Load RGB Colors for selected Account via service',
    props<{ rgbColorsForAccount: number }>()
)

export const setRGBColors = createAction(
    '[RGB Color] Set RGB Colors for selected Account via service Success',
    props<{ rgbColors: Color[] }>()
)

export const setRGBColorsFail = createAction(
    '[RGB Color] Set RGB Colors for selected Account via service Failed',
    props<{ error: any }>()
)

export const add = createAction(
    '[RGB Color] Add RGB Colors for selected Account via service Success',
    props<{ color: Color }>()
)

export const deleteRGB = createAction(
    '[RGB Color] Delete RGB Colors for selected Account via service Success',
    props<{ id: number }>()
)

export const clear = createAction(
    '[RGB Color] Clear all colors'
);

export const rgbColorActionTypes = {
    loadRGBColors,
    setRGBColors,
    setRGBColorsFail,
    add,
    deleteRGB,
    clear
};
